module.exports = __webpack_public_path__ + "static/media/Landing Page Banner_Desktop 1x.b39c4e66.jpg";